/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetMeetingQueryResult } from '../../models/get-meeting-query-result';

export interface ApiMeetingsGetMeetingGet$Params {
  Id?: string;
}

export function apiMeetingsGetMeetingGet(http: HttpClient, rootUrl: string, params?: ApiMeetingsGetMeetingGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMeetingQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiMeetingsGetMeetingGet.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetMeetingQueryResult>;
    })
  );
}

apiMeetingsGetMeetingGet.PATH = '/api/Meetings/GetMeeting';
